/** Pedidos de compra de demonstração. Espelham a semente da migração `0016`. */

import type { StatusDoPedido } from './tipos';

export interface PedidoSemente {
    id: string;
    numero: string;
    fornecedorId: string;
    status: StatusDoPedido;
    previsaoEntrega?: string;
    observacoes?: string;
    criadoEm: string;
    criadoPor?: string;
    enviadoEm?: string;
    recebidoEm?: string;
    itens: {
        id: string;
        produtoId: string;
        quantidade: number;
        quantidadeRecebida: number;
        custoUnitarioCentavos: number;
    }[];
}

/* Um pedido já recebido — é dele que veio a entrada de 24 máscaras que está no
   extrato do estoque — e um enviado, esperando o fornecedor: sem ele a tela não
   teria em que exercer a ação de receber. */
export const PEDIDOS: PedidoSemente[] = [
    {
        id: 'pdc-1',
        numero: '#2026-0001',
        fornecedorId: 'for-2',
        status: 'recebido',
        previsaoEntrega: '2026-09-03',
        observacoes: 'NF 88214',
        criadoEm: '2026-08-28T10:00:00-03:00',
        enviadoEm: '2026-08-28T10:00:00-03:00',
        recebidoEm: '2026-09-03T14:00:00-03:00',
        itens: [{ id: 'pdi-1', produtoId: 'prd-4', quantidade: 24, quantidadeRecebida: 24, custoUnitarioCentavos: 2200 }],
    },
    {
        id: 'pdc-2',
        numero: '#2026-0002',
        fornecedorId: 'for-1',
        status: 'enviado',
        previsaoEntrega: '2026-09-15',
        observacoes: 'Reposição da toxina e das agulhas',
        criadoEm: '2026-09-08T09:00:00-03:00',
        enviadoEm: '2026-09-08T09:00:00-03:00',
        itens: [
            { id: 'pdi-2', produtoId: 'prd-1', quantidade: 6, quantidadeRecebida: 0, custoUnitarioCentavos: 89000 },
            { id: 'pdi-3', produtoId: 'prd-5', quantidade: 200, quantidadeRecebida: 0, custoUnitarioCentavos: 120 },
        ],
    },
];
